
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manuals",
      function () {
        return require("private-next-pages/manuals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manuals"])
      });
    }
  